// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"47d27857","142":"863d1981","419":"1d82f617"}[chunkId] + ".chunk.css";
};